import React from 'react';
import './responsive-image.scss';

export function ResponsiveImage({ src, className, alt, width, height }) {
  const maxWidthList = [576, 768, 992, 1120, 4000];
  const baseUrl = 'https://res.cloudinary.com/dispanserak1000by/image/upload/';

  const sizeObjs = maxWidthList.map(w => ({
    width: Math.min(width, w),
    height: Math.round((Math.min(width, w) / width) * height),
    maxWidth: w
  }));

  const srcSet = sizeObjs
    .map(
      size =>
        `${baseUrl}/w_${size.width},h_${size.height},c_scale${src}, ${size.width}w`
    )
    .join(',');

  const sizes = sizeObjs
    .map(size => `(max-width: ${size.maxWidth}px) ${size.width}px`)
    .join(',');

  const defaultSrc = baseUrl + src;

  return (
    <img
      srcSet={srcSet}
      sizes={sizes}
      src={defaultSrc}
      alt={alt}
      className={className}
    />
  );
}

export default ResponsiveImage;
